import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router'
import { EmptyState } from '@/shared/ui/EmptyState'
import { Icon } from '@/shared/ui/Icon'
import { Link } from '@/shared/ui/Link'

/**
 * Раздел есть, а права на него нет (`docs/roles/03-frontend-architecture.md` §6). Рисуется на
 * том же адресе внутри каркаса: без перенаправлений и без ложного «не найдено». Какого права
 * не хватает, не говорим — устройство прав пользователю не нужно.
 */
export function NoAccessPage() {
  const { t } = useTranslation()

  return (
    <EmptyState
      heading={t('shell.noAccess.title')}
      headingLevel={2}
      icon={<Icon name="warn" size="lg" />}
      size="lg"
      actions={
        <Link
          variant="standalone"
          size="md"
          iconLeft={<Icon name="home" size="xs" />}
          render={(props) => <RouterLink {...props} to="/" />}
        >
          {t('shell.noAccess.home')}
        </Link>
      }
    >
      {t('shell.noAccess.text')}
    </EmptyState>
  )
}
